import { render, staticRenderFns } from "./MyApplicationDeatil.vue?vue&type=template&id=2b8f6d8d&"
import script from "./MyApplicationDeatil.vue?vue&type=script&lang=js&"
export * from "./MyApplicationDeatil.vue?vue&type=script&lang=js&"
import style0 from "./MyApplicationDeatil.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports